module.exports = __webpack_public_path__ + "img/ic_save_coin.224d5f48.svg";